import { Grid, IconButton, Tooltip } from '@material-ui/core'
import Programa from '../../../components/Programa/Programa'
import React, { useCallback, useEffect, useState } from 'react'
import Table from '../../../components/Table/Table'
import { metodoPrograma } from '../../../components/api'
import { MdAdd, MdArrowBack } from 'react-icons/md'
import { Cadastro } from './Cadastro'

const Pais = () => {
  const [lista, setLista] = useState([])
  const [tela, setTela] = useState('lista')
  const [ferramentas, setFerramentas] = useState()
  const [objeto, setObjeto] = useState([])

  const getLista = useCallback(() => {
    metodoPrograma('lista', {}).then((res) => {
      if (res.status) {
        if (res.lista) {
          setLista(res.lista)
        } else {
          setLista([])
        }
      }
    })
  }, [])

  const handleClick = (_, linha) => {
    setObjeto(linha)
    setTela('opcoes')
  }

  const voltar = () => {
    setTela('lista')
    setObjeto([])
    getLista()
  }

  useEffect(() => {
    getLista()
  }, [getLista])

  useEffect(() => {
    switch (tela) {
      case 'lista':
        setFerramentas(
          <Tooltip title="Adicionar País">
            <IconButton onClick={() => setTela('opcoes')}>
              <MdAdd />
            </IconButton>
          </Tooltip>,
        )
        break
      case 'opcoes':
        setFerramentas(
          <Tooltip title="Voltar">
            <IconButton onClick={voltar}>
              <MdArrowBack />
            </IconButton>
          </Tooltip>,
        )
        break
      default:
        break
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tela])

  return (
    <Programa codigo="CtrlPais" ferramentas={ferramentas}>
      {tela === 'lista' ? (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Table
              dados={lista}
              head={['Sigla', 'Nome', '']}
              line={(l) => [l[0], l[1], '']}
              onClick={handleClick}
            />
          </Grid>
        </Grid>
      ) : (
        <Cadastro {...{ objeto, voltar }} />
      )}
    </Programa>
  )
}

export default Pais
